import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { NzTableData } from '../utilities/nz-table.adapter';
import * as urls from '../utilities/urls';
import { OrdersSearch } from 'src/app/models/orders';


@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  private subject = new Subject<any>();
  public clearCartList : Subject<string> = new Subject<string>(); 
  constructor(private httpClient: HttpClient, private router: Router) { }

  // For Tier Limit List with pagination
  getOrdersWithLimit(tableData: NzTableData<OrdersSearch, any>) {
    const value = {
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex
    };
     return this.httpClient.post(urls.OrdersUrls.listCart, value);
  }
// For All Product Limit List with pagination
  getAllProductlist(tableData: NzTableData<OrdersSearch, any>) {
    const value = {
      merchantId: tableData.search.merchantId,
      productName: tableData.search.productName,
      isAvailable: tableData.search.isAvailable, 
      locationId : tableData.search.locationId ? tableData.search.locationId : '',
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
      endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
      includeOffer : true,
      appCode:tableData.search.appCode
    }
      return this.httpClient.post(urls.OrdersUrls.allProductlist, value);
  }
  // For Select Product Limit List with pagination
  getSelectProductListWithLimit(tableData: NzTableData<OrdersSearch, any>) {
    const value = {
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      locationId:tableData.search.locationId,
      status:tableData.search.status,
      userCartId:tableData.search.userCartId
    };
       return this.httpClient.post(urls.OrdersUrls.selectProductList, value);
  }
  // get Total Amount
  getTotalAmount(userCartId){
     const value={

    }
    return this.httpClient.post(urls.OrdersUrls.getTotalAmount+userCartId,value);
  }
  //clear cart
  clearCartAction(event){
   return this.clearCartList.next(event);
  }
  // select Product Create Cart
  selectProductCreateCart(value) {
    return this.httpClient.post(urls.OrdersUrls.createCartProduct, value);
  } 
  //list merchant order logs
  getMerchantOrderLogs(tableData: NzTableData<OrdersSearch , any>) {
  const value = {
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex,
    id: tableData.search.id,
    orderStatus: tableData.search.orderStatus,
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    appCode: tableData.search.appCode,
    merchantLocationId:tableData.search.locationId ,
    mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
    accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
    displayName: tableData.search.type === 'display_name' ? tableData.search.displayName : '',
    orderCreatedFrom:tableData.search.orderCreatedFrom,
    orderNumber:tableData.search.orderNumber,
   };
    return this.httpClient.post(urls.MerchantOrderlogUrls.orderList, value);
  }
  downloadMerchantOrderLogsDetails(value){
    return this.httpClient.post(urls.MerchantOrderlogUrls.orderList,value);
  }
  createMerchantOrderLogs(value){
    return this.httpClient.post(urls.MerchantOrderlogUrls.createLogs, value);

  }
  editMerchantOrder(id,value){
    return this.httpClient.patch(urls.MerchantOrderlogUrls.editOrder+id,value)


  }
  deleteMerchantOrder(id){
    return this.httpClient.delete(urls.MerchantOrderlogUrls.deleteOrder + id);

  }
  getOrderLogs(value){
    console.log('log',value);
  return this.httpClient.post(urls.MerchantOrderlogUrls.logOrder, value);
 
  }
    // For all products
    clearSearchFields(tableData: NzTableData<OrdersSearch, any>, value) {
      if (value === 'orderNumber') {
        return tableData.search.orderNumber = '';
      }
     else if (value === 'Id') {
        return tableData.search.locationId = '';
      }
      else if (value === 'productName') {
        return tableData.search.productName = '';
      }
      else if (value === 'displayName') {
        return tableData.search.displayName = '';
      }
      else if (value === 'number') {
        return tableData.search.number = '';
      }
    }
  editUserCartItem(value,id){ 
    return this.httpClient.patch(urls.MerchantOrderlogUrls.editUserCartItem+id,value)
  }  
  // select Product Create Cart Item
  selectProductCreateCartItem(value) {
    return this.httpClient.post(urls.OrdersUrls.createCartItem, value);
  } 
  deleteCartItem(id) {
    return this.httpClient.delete(urls.OrdersUrls.deleteCartItem + id);
  }
  clearCartItem(id) {
    return this.httpClient.delete(urls.OrdersUrls.clearCartItem + id);
  }
  holdCartItems(value){
    return this.httpClient.patch(urls.OrdersUrls.holdCartItems+value.cartId,value);
  }
  pendingCartItems(tableData: NzTableData<OrdersSearch, any>){
    const value ={
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex,
    status:tableData.search.status,
    merchantLocationId:tableData.search.locationId,
    appCode:tableData.search.appCode
    }
     return this.httpClient.post(urls.OrdersUrls.listCart,value);
  }
  createOrder(value){
    return this.httpClient.post(urls.OrdersUrls.createOrder,value)
  }
  updateOrder(value,id){
    return this.httpClient.patch(urls.OrdersUrls.updateOrder+id,value);
  }
  createReceipt(value){
    return this.httpClient.post(urls.OrdersUrls.createReceipt,value);
  }
  orderReceiptListWithLimit(tableData: NzTableData<OrdersSearch, any>){
     const value ={
      pageSize: tableData.pageSize,
      pageIndex:tableData.pageIndex,
      orderId:tableData.search.id
    }
    return this.httpClient.post(urls.OrdersUrls.orderReceiptList,value)
  }
// For Countries filter in payout Agent
getAllCountries() {
  const value = {};
  return this.httpClient.post(urls.OrdersUrls.countryList, value);
}
}

